import { FC, useRef, useState } from "react";
import "./style.scss";
import GoBack from "../../../../assets/AuthBack.svg";
import Chat from "../../../../assets/ChatColored.svg";
import AuthChat from "../../../../assets/AuthChat.svg";
import AuthPhone from "../../../../assets/AuthPhone.svg";
import WhatsAppIcon from "../../../../assets/WhatsApp.svg";
import { useTranslation } from "react-i18next";
import { getTelUrl, getWhatsAppUrl } from "static/contacts";
import { useNavigate } from "react-router-dom";
import { PATH_LIST } from "shared/lib/react-router";
import { ZohoBmApi, ZohoBmWidget } from "widgets/chat/zoho-bm-widget";
import { useStore } from "zustand";
import { sessionStore, useUserName } from "entities/session/model/sessionModel";

export type BtnPropsType = {
  onClick: () => void;
  img: string;
  name: string;
  disabled?: boolean;
};

export const AuthChatBtn: FC<BtnPropsType> = ({
  onClick,
  img,
  name,
  disabled,
}) => (
  <button
    onClick={onClick}
    className="auth-chat-btn"
    id="brevo-chat-button"
    disabled={disabled}
  >
    <img src={img} alt={name} />
    <p>{name}</p>
  </button>
);

export type PropsType = {
  onClose: () => void;
  localChat?: boolean;
};

export const AuthContactsModal: FC<PropsType> = ({ onClose, localChat }) => {
  const [chatReady, setChatReady] = useState(false);

  const { user } = useStore(sessionStore);
  const userName = useUserName();

  const { t } = useTranslation("onboarding");
  const { t: o } = useTranslation("onboarding-auth");
  const bmRef = useRef<ZohoBmApi | null>(null);
  const navigate = useNavigate();

  return (
    <div className="auth-chat-modal-page">
      <div className="auth-chat-modal-page-header">
        <img
          className="go-back-portfolio"
          onClick={onClose}
          src={GoBack}
          alt="Go Back"
        />
        <p>{t("support")}</p>
      </div>

      <div className="auth-chat-modal-page-main">
        <div className="auth-chat-modal-main-top">
          <img src={Chat} alt="chat" />
          <p>{t("happyToHelp")}</p>
          <span>{t("selectContactMethod")}</span>
        </div>
        <div className="auth-chat-modal-main-bottom">
          {localChat ? (
            <AuthChatBtn
              onClick={() => navigate(PATH_LIST.support)}
              img={AuthChat}
              name={t("chat")}
            />
          ) : (
            <AuthChatBtn
              disabled={!chatReady}
              onClick={() => {
                bmRef.current?.open();
              }}
              img={AuthChat}
              name={t("chat") + (chatReady ? "" : " (" + o("loading") + "...)")}
            />
          )}

          <AuthChatBtn
            onClick={() => (window.location.href = getTelUrl())}
            img={AuthPhone}
            name={t("call")}
          />

          <AuthChatBtn
            onClick={() => window.open(getWhatsAppUrl(), "_blank")}
            img={WhatsAppIcon}
            name="WhatsApp"
          />
        </div>
      </div>

      <ZohoBmWidget
        channelId={"ebd1280c3b5f5508989c548c7658e518"}
        // widgetContainerId="zoho-bm-container"
        layout={{
          needCloseIcon: false,
          needWidgetBubble: false,
        }}
        visitor={
          user
            ? {
                email: user.email || "",
                name: userName || "",
                phone: user.phone || "",
              }
            : undefined
        }
        onReady={(api) => {
          bmRef.current = api;
          setChatReady(true);
        }}
        onError={(err) => {
          console.error("Zoho BM failed:", err);
        }}
      />

      {/* Optional container if you use widgetContainerId */}
      {/* <div id="zoho-bm-container" /> */}
    </div>
  );
};
